import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  useMediaQuery,
  Drawer,
  List,
  ListItem,
  ListItemText,
  IconButton,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

const LandingNavbar: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const isMobile = useMediaQuery("(max-width:970px)");
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  // Scroll effect to change background on scroll
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleDrawer = () => {
    setDrawerOpen((prev) => !prev);
  };

  const handleScrollTo = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    if (drawerOpen) toggleDrawer(); // Close drawer on mobile after navigation
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        transition: "background-color 0.5s ease",
        backgroundColor: scrolled ? "#f3f4f6" : "transparent",
        boxShadow: scrolled ? "0px 4px 12px rgba(0, 0, 0, 0.1)" : "none",
        color: scrolled ? "#012e57" : "white",
        py:{xs:scrolled ? "20px" :"20px",lg:scrolled ? "20px" : "20px"}
      }}
    >
      <Toolbar
        sx={{
          top: 0,
          left: 0,
          right: 0,
          paddingTop: "10px",
          zIndex: 50,
        }}
      >
        <img
          src="logo.png"
          alt="Logo"
          style={{
            height: isSmallScreen ? "40px" : "50px",
            width: isSmallScreen ? "40px" : "50px",
            marginRight: "10px",
          }}
        />
        <Typography
          variant="h6"
          component="div"
          sx={{
            flexGrow: 1,
            fontSize: isSmallScreen ? "18px" : "22px",
            fontWeight: "bold",
            cursor: "pointer",
          }}
          onClick={() => handleScrollTo("/home")}
        >
          Matt Scholar Solutions
        </Typography>

        {isMobile ? (
          <IconButton edge="start" color="inherit" aria-label="menu" onClick={toggleDrawer}>
            <MenuIcon />
          </IconButton>
        ) : (
          <Box sx={{ flexGrow: 2, display: "flex", gap: 2 }}>
            <Button color="inherit" onClick={() => handleScrollTo("home")}>Home</Button>
            <Button color="inherit" onClick={() => handleScrollTo("about")}>About</Button>
            <Button color="inherit" onClick={() => handleScrollTo("services")}>Services</Button>
            <Button color="inherit" onClick={() => handleScrollTo("contact")}>Contact</Button>
          </Box>
        )}

        <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer}>
          <List sx={{ width: 250 }}>
            <ListItem button onClick={() => handleScrollTo("home")}>
              <ListItemText primary="Home" />
            </ListItem>
            <ListItem button onClick={() => handleScrollTo("about")}>
              <ListItemText primary="About" />
            </ListItem>
            <ListItem button onClick={() => handleScrollTo("services")}>
              <ListItemText primary="Services" />
            </ListItem>
            <ListItem button onClick={() => handleScrollTo("contact")}>
              <ListItemText primary="Contact" />
            </ListItem>
          </List>
        </Drawer>
      </Toolbar>
    </AppBar>
  );
};

export default LandingNavbar;
